var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text",style:(_vm.styleColor)},[_c('marquee',{attrs:{"behavior":"","direction":_vm.styleColor.direction}},[_vm._v(_vm._s(_vm.styleColor.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }